import { z } from 'zod';

export const ResolveKitSlotsBodySchema = z.object({
  vehicleModelId: z.uuid().optional(),
  manufactureYear: z.number().int().min(1900).max(2100).optional(),
  vehicleEngineId: z.uuid().optional(),
  placeId: z.uuid().optional(),
});

export const KitSlotCandidateSchema = z.object({
  itemType: z.enum(['PRODUCT', 'SERVICE']),
  itemId: z.uuid(),
  name: z.string(),
  code: z.string().nullable(),
  sku: z.string().nullable(),
});

export const KitSlotSelectionSchema = z.enum(['SINGLE', 'MULTIPLE']);

export const KitResolvedSlotSchema = z.object({
  categoryId: z.uuid(),
  position: z.number().int().nonnegative(),
  quantity: z.number().int(),
  allocationWeight: z.number().int(),
  candidates: z.array(KitSlotCandidateSchema),
  selection: KitSlotSelectionSchema,
  preselectedItemId: z.uuid().optional(),
});

export const ResolveKitSlotsResponseSchema = z.object({
  kitId: z.uuid(),
  name: z.string(),
  slots: z.array(KitResolvedSlotSchema),
});

export type ResolveKitSlotsBody = z.infer<typeof ResolveKitSlotsBodySchema>;
export type KitSlotCandidate = z.infer<typeof KitSlotCandidateSchema>;
export type KitSlotSelection = z.infer<typeof KitSlotSelectionSchema>;
export type KitResolvedSlot = z.infer<typeof KitResolvedSlotSchema>;
export type ResolveKitSlotsResponse = z.infer<typeof ResolveKitSlotsResponseSchema>;
